/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode, useEffect } from 'react';
import { restoreSession, sessionIdVar } from '../../state/session';

import { LoadingPage } from '../../pages/Loading/LoadingPage';
import { ReactiveVar } from '@apollo/client/cache/inmemory/reactiveVars';
import { useAppStateFromDeeplinks } from '../DeepLinkProvider/DeepLinkProvider';
import { useHistory } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { z } from 'zod';

interface AppStateProviderProps {
  children: ReactNode;
  stateVars: Record<string, ReactiveVar<any>>;
  appStateSchema: z.ZodObject<any, any>;
}

export function AppStateProvider({
  children,
  stateVars,
  appStateSchema,
}: AppStateProviderProps) {
  const history = useHistory();
  const appState = useAppStateFromDeeplinks();

  const sessionId = useReactiveVar(sessionIdVar);

  useEffect(() => {
    if (!sessionId) {
      restoreSession(history, stateVars, appStateSchema, appState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  if (!sessionId) {
    return <LoadingPage />;
  }

  return <>{children}</>;
}
